import { render, staticRenderFns } from "./knowledgeLibs.vue?vue&type=template&id=c4017bcc&scoped=true&"
import script from "./knowledgeLibs.vue?vue&type=script&lang=js&"
export * from "./knowledgeLibs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4017bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4017bcc')) {
      api.createRecord('c4017bcc', component.options)
    } else {
      api.reload('c4017bcc', component.options)
    }
    module.hot.accept("./knowledgeLibs.vue?vue&type=template&id=c4017bcc&scoped=true&", function () {
      api.rerender('c4017bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deviceMgr/components/knowledgeLibs.vue"
export default component.exports